/** The draft path of the script behind a Command, if the solution has one. */
export const findCommandScriptPath = (
  command: string,
  draftFiles: readonly string[]
): string | undefined => {
  if (!command) return undefined;
  const path = `services/${command}.py`;
  return draftFiles.includes(path) ? path : undefined;
};
